/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectRequestRequestDto } from './projectRequestRequestDto.model';
import { ProjectActualizationDto } from './projectActualizationDto.model';
import { ProjectDefaultDto } from './projectDefaultDto.model';
import { ProjectOptionResponseDto } from './projectOptionResponseDto.model';


export interface ProjectResponseDto { 
    allowActualization?: boolean;
    allowLiquibase?: boolean;
    blockUsers?: boolean;
    customerId?: number;
    id?: number;
    key?: string;
    name?: string;
    projectActualization?: ProjectActualizationDto;
    projectDefault?: ProjectDefaultDto;
    projectOption?: ProjectOptionResponseDto;
    projectRequest?: ProjectRequestRequestDto;
}

